/* eslint-disable @typescript-eslint/naming-convention */
import { FuncOrGroup } from '@react-awesome-query-builder/antd';

const MAX = (customFields: any): FuncOrGroup => ({
  label: 'MAX',
  sqlFunc: 'MAX',
  returnType: 'number',
  args: {
    numbers: {
      label: 'Numbers',
      type: 'a8multiselect',
      valueSources: ['value'],
      listValues: Object.keys(customFields),
      allowCustomValues: true,
    },
    valueOrFunc: {
      label: 'Value or Function',
      type: 'number',
      valueSources: ['value', 'func'],
      allowCustomValues: true
    }
  },
  allowSelfNesting: true,
  jsonLogic: (formattedArgs) => {
    const selectedFields = formattedArgs.numbers.split(',').map(field => ({ var: field }));
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    let options = [...selectedFields];
    
    if (valueOrFunc) {
      if (typeof valueOrFunc === 'object' && valueOrFunc.func) {
        options.push(valueOrFunc);
      } else {
        options.push(valueOrFunc);
      }
    }
    
    return {
      max: options
    };
  },
  formatFunc: (formattedArgs) => {
    const selectedFields = formattedArgs.numbers.split(',').join(', ');
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    if (valueOrFunc) {
      return `MAX(${selectedFields}, ${valueOrFunc})`;
    }
    return `MAX(${selectedFields})`;
  },
  sqlFormatFunc: (formattedArgs) => {
    const selectedFields = formattedArgs.numbers.split(',').join(', ');
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    if (valueOrFunc) {
      return `MAX(${selectedFields}, ${valueOrFunc})`;
    }
    return `MAX(${selectedFields})`;
  }
});

export default MAX;
